import React, { useEffect, useState, useRef } from 'react';
import { useCalendar } from './CalenderContext';
import axios from 'axios';
import { BASE_URL } from "../../config/axios";
import { DropdownArrow } from '../AllSvg';
import { Modal } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import { ViewEmployeeList, handleErrorToast } from '../CustomFunctions';
import { AddwithWhiteCircle, Eye, View } from "../AllSvg";




const calculateDuration = (startTime, endTime) => {
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const [endHour, endMinute] = endTime.split(':').map(Number);

    let totalMinutes = (endHour * 60 + endMinute) - (startHour * 60 + startMinute);

    if (totalMinutes < 0) {
        totalMinutes += 24 * 60;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) {
        return `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
    } else if (hours > 0) {
        return `${hours} hour${hours !== 1 ? 's' : ''}`;
    } else {
        return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }
};





const MobileTimePicker = ({ onTimeSelect, initialTime, formData, handleSelectClick }) => {

    const initialTimeRef = useRef(
        formData?.start_time
            ? formData.start_time
            : initialTime
                ? (initialTime instanceof Date
                    ? `${String(initialTime.getHours()).padStart(2, '0')}:${String(initialTime.getMinutes()).padStart(2, '0')}`
                    : initialTime)
                : `${String(new Date().getHours()).padStart(2, '0')}:${String(new Date().getMinutes()).padStart(2, '0')}`
    );

    const [selectedTime, setSelectedTime] = useState(new Date());
    const [displayHour, setDisplayHour] = useState('12');
    const [displayMinute, setDisplayMinute] = useState('00');
    const [amPm, setAmPm] = useState('AM');
    const [isHourView, setIsHourView] = useState(false);
    const [minuteHandAngle, setMinuteHandAngle] = useState(0);
    const [hourHandAngle, setHourHandAngle] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const clockRef = useRef(null);

    useEffect(() => {
        const initializeTime = (timeString) => {
            if (!timeString) return;

            const [hours, minutes] = timeString.split(':').map(num => parseInt(num));
            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            setSelectedTime(date);
            updateDisplayValues(date);
        };

        initializeTime(initialTimeRef.current);
    }, []);


    useEffect(() => {
        if (formData?.start_time) {
            const [hours, minutes] = formData.start_time.split(':').map(num => parseInt(num));
            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            setSelectedTime(date);
            updateDisplayValues(date);
        }
    }, [formData]);

    const updateDisplayValues = (time) => {
        if (!(time instanceof Date)) {
            return;
        }

        let hours = time.getHours();
        const minutes = time.getMinutes();
        const isAm = hours < 12;


        const hourAngle = ((hours % 12) * 30) + (minutes * 0.5);
        setHourHandAngle(hourAngle);


        const minuteAngle = minutes * 6;
        setMinuteHandAngle(minuteAngle);


        if (hours > 12) {
            hours -= 12;
        } else if (hours === 0) {
            hours = 12;
        }

        setDisplayHour(hours.toString());
        setDisplayMinute(minutes.toString().padStart(2, '0'));
        setAmPm(isAm ? 'AM' : 'PM');
    };

    const switchToHourView = () => {
        setIsHourView(true);
    };

    const switchToMinuteView = () => {
        setIsHourView(false);
    };

    const handleHourClick = () => {
        switchToHourView();
    };

    const handleMinuteClick = () => {
        switchToMinuteView();
    };

    const toggleAmPm = (e, value) => {
        e.preventDefault();
        setAmPm(value);
        // updateSelectedTime();
    };

    const updateSelectedTime = () => {
        const newTime = new Date(selectedTime);


        let hourValue = parseInt(displayHour || '12');
        if (amPm === 'PM' && hourValue !== 12) {
            hourValue += 12;
        } else if (amPm === 'AM' && hourValue === 12) {
            hourValue = 0;
        }

        newTime.setHours(hourValue);
        newTime.setMinutes(parseInt(displayMinute || '0'));

        setSelectedTime(newTime);


        const formattedHour = String(hourValue).padStart(2, '0');
        const formattedMinute = String(parseInt(displayMinute || '0')).padStart(2, '0');
        const timeString = `${formattedHour}:${formattedMinute}`;

        if (onTimeSelect) {
            onTimeSelect(timeString);
        }

        return timeString;
    };

    const calculateAngleFromEvent = (e) => {
        if (!clockRef.current) return 0;

        const rect = clockRef.current.getBoundingClientRect();
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        let clientX, clientY;


        if (e.type.startsWith('touch')) {
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
        } else {
            clientX = e.clientX;
            clientY = e.clientY;
        }

        const x = clientX - rect.left - centerX;
        const y = clientY - rect.top - centerY;


        let angle = Math.atan2(y, x) * (180 / Math.PI) + 90;


        if (angle < 0) angle += 360;

        return angle;
    };

    const handleClockClick = (e) => {
        if (isDragging) return;

        const angle = calculateAngleFromEvent(e);

        if (isHourView) {

            let hour = Math.round(angle / 30) % 12;
            if (hour === 0) hour = 12;

            setDisplayHour(hour.toString());
            setHourHandAngle(hour * 30);


            setTimeout(() => {
                switchToMinuteView();
            }, 500);
        } else {

            const minute = Math.round(angle / 6) % 60;
            setDisplayMinute(minute.toString().padStart(2, '0'));
            setMinuteHandAngle(minute * 6);
        }

        // updateSelectedTime();
    };

    const handleMouseDown = (e) => {
        if (e.type === 'touchstart') {
            e.preventDefault();
        }
        setIsDragging(true);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        document.addEventListener('touchmove', handleMouseMove, { passive: false });
        document.addEventListener('touchend', handleMouseUp);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        if (e.type === 'touchmove') {
            e.preventDefault();
        }

        const angle = calculateAngleFromEvent(e);

        if (isHourView) {

            let hour = Math.round(angle / 30) % 12;
            if (hour === 0) hour = 12;

            setDisplayHour(hour.toString());
            setHourHandAngle(hour * 30);
        } else {

            const minute = Math.round(angle / 6) % 60;
            setDisplayMinute(minute.toString().padStart(2, '0'));
            setMinuteHandAngle(minute * 6);
        }

        // updateSelectedTime();
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('touchmove', handleMouseMove);
        document.removeEventListener('touchend', handleMouseUp);


        if (isHourView) {
            setTimeout(() => {
                switchToMinuteView();
            }, 300);
        }
    };


    const generateClockMarkers = () => {
        const markers = [];

        if (isHourView) {

            for (let i = 1; i <= 12; i++) {
                const angle = (i / 12) * 360 - 90;
                const x = 50 + 40 * Math.cos(angle * Math.PI / 180);
                const y = 50 + 40 * Math.sin(angle * Math.PI / 180);

                const isActive = parseInt(displayHour) === i;

                markers.push(
                    <div
                        key={`hour-${i}`}
                        className={`marker hour-marker ${isActive ? 'active' : ''}`}
                        style={{
                            left: `${x}%`,
                            top: `${y}%`,
                        }}
                    >
                        {i}
                    </div>
                );
            }
        } else {

            for (let i = 0; i < 12; i++) {
                const minute = i * 5;
                const angle = (minute / 60) * 360 - 90;
                const x = 50 + 40 * Math.cos(angle * Math.PI / 180);
                const y = 50 + 40 * Math.sin(angle * Math.PI / 180);

                const isActive = parseInt(displayMinute) === minute;

                markers.push(
                    <div
                        key={`minute-${i}`}
                        className={`marker minute-marker ${isActive ? 'active' : ''}`}
                        style={{
                            left: `${x}%`,
                            top: `${y}%`,
                        }}
                    >
                        {minute.toString().padStart(2, '0')}
                    </div>
                );
            }
        }

        return markers;
    };


    const formatTimeOutput = () => {
        let hourValue = parseInt(displayHour);
        if (amPm === 'PM' && hourValue !== 12) {
            hourValue += 12;
        } else if (amPm === 'AM' && hourValue === 12) {
            hourValue = 0;
        }

        const formattedHour = String(hourValue).padStart(2, '0');
        const formattedMinute = displayMinute;
        handleSelectClick()
        return `${formattedHour}:${formattedMinute}`;
    };

    return (
        <>
            <div className="mobile-time-picker">
                <div className="time-picker-header">
                    <div className="time-display">
                        <div
                            className={`time-section ${isHourView ? 'active' : ''}`}
                            onClick={handleHourClick}
                        >
                            <span className="time-input hour">{displayHour}</span>
                        </div>
                        <div className="time-separator">:</div>
                        <div
                            className={`time-section ${!isHourView ? 'active' : ''}`}
                            onClick={handleMinuteClick}
                        >
                            <span className="time-input minute">{displayMinute}</span>
                        </div>
                    </div>
                    <div className="ampm-toggle">
                        <button
                            className={`ampm-btn ${amPm === 'AM' ? 'active' : ''}`}
                            onClick={(e) => toggleAmPm(e, 'AM')}
                        >
                            AM
                        </button>
                        <button
                            className={`ampm-btn ${amPm === 'PM' ? 'active' : ''}`}
                            onClick={(e) => toggleAmPm(e, 'PM')}
                        >
                            PM
                        </button>
                    </div>
                </div>

                <div
                    className="clock-container"
                    onClick={handleClockClick}
                    ref={clockRef}
                >
                    <div className="clock-face">
                        {generateClockMarkers()}

                        {isHourView ? (
                            <div
                                className="hour-hand"
                                style={{ transform: `rotate(${hourHandAngle}deg)` }}
                                onMouseDown={handleMouseDown}
                                onTouchStart={handleMouseDown}
                            >
                                <div className="hour-handle"></div>
                                <div className="hand-knob"></div>
                            </div>
                        ) : (
                            <div
                                className="minute-hand"
                                style={{ transform: `rotate(${minuteHandAngle}deg)` }}
                                onMouseDown={handleMouseDown}
                                onTouchStart={handleMouseDown}
                            >
                                <div className="minute-handle"></div>
                                <div className="hand-knob"></div>
                            </div>
                        )}

                        <div className="center-dot"></div>
                    </div>
                </div>

                <div className="time-picker-footer">
                    <button className="cancel-btn" onClick={(e) => {
                        e.preventDefault()
                        onTimeSelect(null)
                        handleSelectClick()
                    }}>Cancel</button>
                    <button className="ok-btn" onClick={(e) => {
                        e.preventDefault()
                        onTimeSelect(formatTimeOutput())
                    }}>OK</button>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};











const AddEventModal = ({ showModal, onClose, selectedEvent, dayPosition, timeSlots, selectedTimeslot, getMeetingData, Handlecloseallmodal, closeMeetingModal, selectedDate }) => {

    const [isVisible, setIsVisible] = useState(false); // Controls visibility
    const [isMounted, setIsMounted] = useState(false); // Controls mounting

    const [formData, setFormData] = useState({
        title: "",
        participants: [],
        created_at: "",
        discription: "",
        organizer: sessionStorage.getItem("emp_code"),
        meeting_date: "",
        start_time: "",
        meeting_duration: "",
        end_time: "",
        outside_venue: "",
        mandatory: false,
        participants_addition_type: "",
        decline_reason: null,
        optional_participents: [],
        room: [],
        isteam: 'No',
        is_outsude: "false",
        outside_email: '',
        team_name: "",
        department: "",
        participants: [],
        participantsteam: '',
        existingteam: "",
        team: "",
        outside_venue: "",
        outside_participants: [
            { name: '', email: '' }
        ]
    });


    const [isClock, setIsClock] = useState(false);
    const [isClockend, setIsClockend] = useState(false);
    // console.log(formData, 'formdata')
    const modalRef = useRef(null);
    const [firsttime, Setfirstime] = useState(true);

    const [roomData, setRoomData] = useState('')
    const getRoomdata = async () => {
        try {

            const result = await axios.get(`${BASE_URL}/meetingscheduler/roomavailabilitycheck/${formData.meeting_date}/${formData.start_time}/${formData.end_time}/`);

            setRoomData(result.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            // setLoading(false); //loading logic
            // toast.dismiss(loadingToastId);
        }


    };

    const [teamlist, SetTeamlist] = useState([]);
    const getTeamdata = async () => {
        try {

            const result = await axios.get(`${BASE_URL}/meetingscheduler/team/`);

            SetTeamlist(result.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            // setLoading(false); //loading logic
            // toast.dismiss(loadingToastId);
        }


    };

    const [allemployee, setAllemployee] = useState([]);
    const getAllEmployee = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/meetingscheduler/employeesavailabilityfilterv2/${formData.meeting_date}/${formData.start_time}/${formData.end_time}/`);
            setAllemployee(res.data)
            // setFilteredEmployee(res.data)
        } catch (err) {
            // alert(err.message);
        }
    };

    const [departmentname, setDepartmentname] = useState([]);
    const [selectedSubCompany, setSelectedSubCompany] = useState('');
    const getDepartment = async () => {
        try {
            const result = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/null/active/`);

            setDepartmentname(result.data)
        } catch (err) {

        } finally {

        }
    };
    const timeSlotsduration = [
        { label: "15 minutes", value: 15 },
        { label: "30 minutes", value: 30 },
        { label: "45 minutes", value: 45 },
        { label: "1 hour", value: 60 },
        { label: "1 hour 15 minutes", value: 75 },
        { label: "1 hour 30 minutes", value: 90 },
        { label: "1 hour 45 minutes", value: 105 },
        { label: "2 hours", value: 120 },
        { label: "2 hours 15 minutes", value: 135 },
        { label: "2 hours 30 minutes", value: 150 },
        { label: "2 hours 45 minutes", value: 165 },
        { label: "3 hours", value: 180 },

    ];
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [loading, setLoading] = useState(false);
    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;

        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }


        // if (name === "meeting_date" && value) {

        //     const selectedDate = new Date(value);
        //     const currentDate = new Date();


        //     selectedDate.setHours(0, 0, 0, 0);
        //     currentDate.setHours(0, 0, 0, 0);


        //     if (selectedDate < currentDate) {
        //         setErrors((prevErrors) => ({
        //             ...prevErrors,
        //             [name]: "Meeting date cannot be in the past.",
        //         }));
        //         return;
        //     } else {

        //         setErrors((prevErrors) => ({
        //             ...prevErrors,
        //             [name]: "",
        //         }));
        //     }
        // }

        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));

        setFormData((prevFormData) => {
            const updatedFormData = { ...prevFormData, [name]: value };

            if (name === "meeting_duration" && value) {

                const selectedDuration = timeSlotsduration.find(slot => slot.value === parseInt(value));

                if (selectedDuration) {
                    const meetingDate = new Date(formData.meeting_date);
                    meetingDate.setMinutes(meetingDate.getMinutes() + selectedDuration.value);

                    const end_time = meetingDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                    console.log(end_time, "end time duration")
                    updatedFormData.end_time = end_time;
                }
            }

            return updatedFormData;
        });
        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };
    const validateform = () => {
        const newErrors = {};
        const requiredFields = [
            "title",
            "start_time",
            "end_time",
            "meeting_date",
            "room",


        ];

        requiredFields.forEach((field) => {

            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        // setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };
    const validateformTeam = () => {
        const newErrors = {};
        const requiredFields = [
            "team_name",
            "department",
            "participants",

        ];

        requiredFields.forEach((field) => {

            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        // setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const meetingDate = new Date(formData.meeting_date);
        const currentDate = new Date();


        meetingDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        if (meetingDate < currentDate) {

            toast.error("Meeting date cannot be a previous date.");
            setLoading(false);
            return;
        }
        setLoading(true);

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {
                const dataToSend = {};

                dataToSend.title = formData?.title;
                dataToSend.discription = formData?.discription;

                dataToSend.created_at = formData?.created_at;
                dataToSend.organizer = formData?.organizer;
                dataToSend.meeting_date = formData?.meeting_date;
                dataToSend.start_time = formData?.start_time;
                dataToSend.end_time = formData?.end_time;

                dataToSend.mandatory = formData?.mandatory;

                dataToSend.decline_reason = formData?.decline_reason;
                dataToSend.optional_participents = formData?.optional_participents;
                if (formData.is_outsude === "true") {
                    dataToSend.outside_venue = formData?.outside_venue;
                    dataToSend.outside_participants = formData?.outside_participants;
                } else {
                    dataToSend.room = formData?.room;
                }


                dataToSend.is_team = formData.isteam === "Yes" ? true : false;
                dataToSend.is_outside = formData.is_outsude === "true" ? true : false;

                dataToSend.participants = formData?.participants;
                if (formData.isteam === "Yes") {
                    dataToSend.team_name = formData.team_name;
                    dataToSend.participantsteam = formData.participantsteam;
                    dataToSend.department = formData.department;
                    dataToSend.team = formData.team
                }


                let res = await axios.post(
                    `${BASE_URL}/meetingscheduler/meeting/`,
                    dataToSend,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (res.status === 201 || res.status === 200) {
                    await getMeetingData()
                    Handlecloseallmodal()
                } else {

                }


            } catch (err) {
                // toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false);
                // loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const handleSubmitteam = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (validateformTeam()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {

                const dataToSend = {};

                dataToSend.team_name = formData?.team_name;
                dataToSend.department = formData?.department;
                dataToSend.participants = formData?.participantsteam;


                let res = await axios.post(
                    `${BASE_URL}/meetingscheduler/team/`,
                    dataToSend,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (res.status === 201 || res.status === 200) {
                    // onRoomCreated(res.data);
                    // onClose();
                    await getTeamdata();
                    setFormData((prevState) => ({
                        ...prevState,
                        team: res.data.id,
                    }));
                } else {

                }


            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                // setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    useEffect(() => {
        if (firsttime && selectedTimeslot) {
            console.log("useefect", selectedTimeslot)
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');

                return `${year}-${month}-${day}`;
            };

            setFormData((prevFormData) => {
                const updatedFormData = {
                    ...prevFormData,
                    start_time: selectedTimeslot.start,
                    end_time: selectedTimeslot.end,
                    meeting_date: formatDate(selectedDate)
                };
                // console.log(updatedFormData)
                return updatedFormData;
            });


        }

    }, [selectedTimeslot, firsttime, selectedDate]);


    useEffect(() => {
        if (formData.meeting_date != "" && formData.start_time != "" && formData.end_time != "") {
            getRoomdata();
            getAllEmployee();
            getDepartment();
            getTeamdata();
        }
    }, [formData.meeting_date, formData.start_time, formData.end_time])

    const handleToggleMandatory = (value) => {
        setFormData((prevFormData) => {
            const updatedAssignedTo = prevFormData.participants.map((participant) => {
                return participant.value === value
                    ? { ...participant, mandatory: !participant.mandatory } // Toggle mandatory flag
                    : participant;
            });

            // Return the updated formData with the modified assignedto array
            return {
                ...prevFormData,
                participants: updatedAssignedTo,
            };
        });
    };


    // Options array with mandatory field
    const options = allemployee?.employees
        ?.sort((a, b) => parseInt(a.employee_id) - parseInt(b.employee_id))
        .map((e) => {
            return {
                value: e.employee_id,
                label: e.is_available
                    ? `${e.employee_id} - ${e.employee_name}`
                    : `${e.employee_id} - ${e.employee_name} (booked)`,
                isAvailable: e.is_available,
                mandatory: e.mandatory || false, // Use mandatory field from the employee object (if available)
            };
        });



    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const participants = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            participants,
        }));
    };






    const selectTeamparticipint = (selected) => {

        const participantsteam = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            participantsteam,
        }));
    };

    const [selectedOption, setSelectedOption] = useState('');
    const [newTeamName, setNewTeamName] = useState('');
    const [assignedTo, setAssignedTo] = useState([]);

    const handleParticipantChange = (index, field, value) => {
        const updatedParticipants = [...formData.outside_participants];
        updatedParticipants[index][field] = value;

        setFormData({ ...formData, outside_participants: updatedParticipants });
    };
    const handleAddParticipant = () => {
        setFormData({
            ...formData,
            outside_participants: [...formData.outside_participants, { name: '', email: '' }],
        });
    };

    const handleDeleteParticipant = (index) => {
        const updatedParticipants = formData.outside_participants.filter((_, i) => i !== index);
        setFormData({ ...formData, outside_participants: updatedParticipants });
    };

    const isAddButtonVisible = formData?.outside_participants?.every(
        (participant) => participant.name && participant.email
    );


    // All other state and functions remain the same from the original component
    // ...

    // Calculate position relative to clicked day
    const calculatePosition = () => {
        if (!dayPosition) return {};

        // Default to center positioning if no dayPosition provided
        const defaultPosition = {
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        };

        if (!dayPosition.x || !dayPosition.y) return defaultPosition;

        // Get calendar dimensions
        const calendar = document.querySelector('.calendar-grid');
        if (!calendar) return defaultPosition;

        const calendarRect = calendar.getBoundingClientRect();

        // Calculate if modal would go off-screen
        const modalWidth = 600; // Estimate modal width
        const modalHeight = 500; // Estimate modal height

        let left = dayPosition.x;
        let top = dayPosition.y + 10; // Offset slightly below the day cell

        // Adjust if too close to right edge
        if (left + modalWidth > calendarRect.right) {
            left = dayPosition.x - modalWidth;
        }

        // Adjust if too close to bottom edge
        if (top + modalHeight > calendarRect.bottom) {
            top = dayPosition.y - modalHeight;
        }

        // Ensure modal doesn't go off the left or top edge
        left = Math.max(calendarRect.left, left);
        top = Math.max(calendarRect.top, top);

        return {
            position: 'absolute',
            left: `${left}px`,
            top: `${top}px`,
            transform: 'none'
        };
    };

    useEffect(() => {
        if (showModal) {
            setIsMounted(true); // Mount the modal
            setTimeout(() => setIsVisible(true), 10); // Slight delay to trigger CSS transition
        } else {
            setIsVisible(false); // Start fade-out transition
            setTimeout(() => setIsMounted(false), 300); // Unmount after transition
        }
    }, [showModal]);
    const [isExpanded, setIsExpanded] = useState(false);
    const handleTimeSelect = (selectedTime) => {
        setFormData((prevData) => ({
            ...prevData,
            start_time: selectedTime,
        }));

        // Calculate end time based on selected start time (for example, 1 hour duration)

    };

    const handleTimeSelectend = (selectedTime) => {
        setFormData((prevData) => ({
            ...prevData,
            end_time: selectedTime,
        }));



    };
    if (!isMounted) return null;

    const handleSelectClick = () => {
        setIsClock(!isClock);
    };

    const handleSelectClickend = () => {
        setIsClockend(!isClockend);
    };

    return (
        <>
            <div className={`calendar-meeting-modal ${isVisible ? 'visible' : ''}`}>
                <div className="model-backdrop" onClick={onClose}></div>
                <div
                    className="modal-content"
                    ref={modalRef}
                // style={calculatePosition()}
                >
                    <div className="modal-header">
                        <h2>{selectedEvent ? 'Update Event' : 'Create Meeting'}  {selectedDate?.toLocaleDateString("en-US", {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                        })}</h2>
                        <button className="close-button" onClick={onClose}>
                            &times;
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* Form content remains the same */}
                        <form className="register-form">
                            <div className="form-flex-wrap">


                                <div title="is_outsude" className="flex-column form-group-selectt">
                                    <label htmlFor="is_outsude" className="form-labels  font-weight500    font-size-subheading">
                                        Meeting Type
                                    </label>

                                    <select
                                        id="is_outsude"
                                        name="is_outsude"
                                        value={formData.is_outsude}
                                        onChange={handleInputChange}
                                        className="form-input form-group-selection"
                                    >
                                        <option value="">Select Meeting Type</option>
                                        <option value="false">Inside</option>
                                        <option value="true">Outside</option>
                                    </select>
                                    <DropdownArrow />
                                    <div>
                                        {errors.is_outsude && (
                                            <span className="error-message font-size-text ">{errors.is_outsude}</span>
                                        )}
                                    </div>
                                </div>




                                <div title="title" className="flex-column">
                                    <label htmlFor="title" className="form-labels font-weight500 font-size-subheading">
                                        Meeting Agenda <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        placeholder="Meeting Agenda"
                                        onChange={handleInputChange}
                                        value={formData.title}
                                        className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""}`}
                                    />
                                    {errors.title && (
                                        <span className="error-message font-size-text">{errors.title}</span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="discription"
                                        className="form-labels font-weight500 font-size-subheading"

                                    >
                                        Meeting Description
                                    </label>
                                    <div
                                        onClick={() => setIsExpanded(!isExpanded)}
                                        className="expand-label"
                                    >
                                        <textarea
                                            id="discription"
                                            name="discription"
                                            placeholder="Enter meeting description"
                                            value={formData.discription}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.discription ? "error" : ""}`}
                                            style={{ minHeight: "20px", resize: "vertical", padding: '5px' }}

                                        />
                                    </div>
                                    {isExpanded && (
                                        <textarea
                                            id="discription"
                                            name="discription"
                                            placeholder="Enter meeting description"
                                            value={formData.discription}
                                            onChange={handleInputChange}

                                            className={`form-input ${errors.discription ? "error" : ""}`}
                                            style={{ minHeight: "150px", resize: "vertical", position: "absolute", top: "30px", zIndex: '999999999' }}
                                        />
                                    )}
                                    {errors.discription && (
                                        <span className="error-message font-size-text">
                                            {errors.discription}
                                        </span>
                                    )}
                                </div>




                                <div title="meeting_date" className="flex-column">
                                    <label htmlFor="meeting_date" className="form-labels font-weight500 font-size-subheading">
                                        Meeting Date <span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="meeting_date"
                                        name="meeting_date"
                                        onChange={handleInputChange}
                                        value={formData.meeting_date}
                                        className={`form-input ${errors.meeting_date ? "error" : inputState.meeting_date ? "success" : ""}`}
                                    />
                                    {errors.meeting_date && (
                                        <span className="error-message font-size-text">{errors.meeting_date}</span>
                                    )}
                                </div>

                                {/* 
                            <div title="start_time" className="flex-column form-group-selectt" style={{ position: 'relative' }}>
                                <label htmlFor="start_time" className="form-labels  font-weight500    font-size-subheading">
                                    Start Time <span className="required">*</span>
                                </label>

                                <select
                                    id="start_time"
                                    name="start_time"
                                    value={formData.start_time}
                                    // onChange={handleInputChange}
                                    onClick={handleSelectClick}
                                    className="form-input form-group-selection"
                                >

                                    {timeSlots.map((slot, index) => {

                                        const ampm = slot.hour < 12 ? 'AM' : 'PM';
                                        const timeString = `${String(slot.hour).padStart(2, '0')}:${String(slot.minute).padStart(2, '0')} ${ampm}`;

                                        return (
                                            <option key={index} value={`${String(slot.hour).padStart(2, '0')}:${String(slot.minute).padStart(2, '0')}`}>
                                                {timeString}
                                            </option>
                                        );
                                    })}
                                </select>
                                <DropdownArrow />
                                <div>
                                    {errors.start_time && (
                                        <span className="error-message font-size-text ">{errors.start_time}</span>
                                    )}
                                </div>
                                {isClock &&

                                    <MobileTimePicker initialTime={formData.start_time}
                                        onTimeSelect={handleTimeSelect}
                                    />
                                }

                            </div> */}

                                <div title="start_time" className="flex-column form-group-selectt" style={{ position: 'relative' }}>
                                    <label htmlFor="start_time" className="form-labels font-weight500 font-size-subheading">
                                        Start Time <span className="required">*</span>
                                    </label>


                                    <div
                                        id="start_time"
                                        className="form-input form-group-selection"
                                        onClick={handleSelectClick}
                                    // style={{ cursor: 'pointer', padding: '10px', border: '1px solid #ccc' }}
                                    >
                                        {formData.start_time ? (() => {
                                            const [hour, minute] = formData.start_time.split(':');
                                            const hourInt = parseInt(hour);
                                            const ampm = hourInt < 12 ? 'AM' : 'PM';
                                            const hour12 = hourInt % 12 || 12;
                                            return `${String(hour12).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;
                                        })() : 'Select Time'}
                                    </div>

                                    <DropdownArrow />

                                    <div>
                                        {errors.start_time && (
                                            <span className="error-message font-size-text">{errors.start_time}</span>
                                        )}
                                    </div>


                                    {isClock && (
                                        <MobileTimePicker initialTime={formData.start_time} onTimeSelect={handleTimeSelect} handleSelectClick={handleSelectClick} />
                                    )}
                                </div>

                                <div title="end_time" className="flex-column form-group-selectt" style={{ position: 'relative' }}>
                                    <label htmlFor="end_time" className="form-labels font-weight500 font-size-subheading">
                                        End Time <span className="required">*</span>
                                    </label>


                                    <div
                                        id="end_time"
                                        className="form-input form-group-selection"
                                        onClick={handleSelectClickend}
                                    // style={{ cursor: 'pointer', padding: '10px', border: '1px solid #ccc' }}
                                    >
                                        {formData.end_time ? (() => {
                                            const [hour, minute] = formData.end_time.split(':');
                                            const hourInt = parseInt(hour);
                                            const ampm = hourInt < 12 ? 'AM' : 'PM';
                                            const hour12 = hourInt % 12 || 12;
                                            return `${String(hour12).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;
                                        })() : 'Select Time'}
                                    </div>

                                    <DropdownArrow />

                                    <div>
                                        {errors.end_time && (
                                            <span className="error-message font-size-text">{errors.end_time}</span>
                                        )}
                                    </div>


                                    {isClockend && (
                                        <MobileTimePicker initialTime={formData.end_time} onTimeSelect={handleTimeSelectend} handleSelectClick={handleSelectClickend} />
                                    )}


                                </div>


                                {/* <div title="meeting_duration" className="flex-column form-group-selectt">
                                <label htmlFor="meeting_duration" className="form-labels font-weight500 font-size-subheading">
                                    Meeting Duration <span className="required">*</span>
                                </label>

                                <select
                                    id="meeting_duration"
                                    name="meeting_duration"
                                    value={formData.meeting_duration}
                                    onChange={handleInputChange}
                                    className="form-input form-group-selection"
                                >

                                    {timeSlotsduration.map((slot, index) => {
                                        return (
                                            <option key={index} value={slot.value}>
                                                {slot.label}
                                            </option>
                                        );
                                    })}
                                </select>
                                <DropdownArrow />
                                <div>
                                    {errors.meeting_duration && (
                                        <span className="error-message font-size-text ">{errors.meeting_duration}</span>
                                    )}
                                </div>
                            </div> */}
                                {/* <div title="end_time" className="flex-column form-group-selectt">
                                <label htmlFor="end_time" className="form-labels font-weight500 font-size-subheading">
                                    End Time <span className="required">*</span>
                                </label>

                                <select
                                    id="end_time"
                                    name="end_time"
                                    value={formData.end_time}
                                    onChange={handleInputChange}
                                    className="form-input form-group-selection"
                                >

                                    {timeSlots.map((slot, index) => {

                                        const ampm = slot.hour < 12 ? 'AM' : 'PM';
                                        const timeString = `${String(slot.hour).padStart(2, '0')}:${String(slot.minute).padStart(2, '0')} ${ampm}`;

                                        return (
                                            <option key={index} value={`${String(slot.hour).padStart(2, '0')}:${String(slot.minute).padStart(2, '0')}`}>
                                                {timeString}
                                            </option>
                                        );
                                    })}
                                </select>
                                <DropdownArrow />
                                <div>
                                    {errors.end_time && (
                                        <span className="error-message font-size-text ">{errors.end_time}</span>
                                    )}
                                </div>
                            </div> */}


                                {
                                    formData.is_outsude === "false" ?
                                        <div className="form-group-selectt" style={{ width: '23vw' }}>
                                            <label className="form-labels  font-weight500 font-size-subheading" style={{ width: '23vw' }}>
                                                Room<span className="required">*</span>
                                            </label>

                                            {roomData.length === 0 ?
                                                <div className="form-loader" style={{ width: '23vw' }}>
                                                    <div className="bar-loader" style={{ width: '23vw' }}></div>
                                                </div>
                                                : <>
                                                    <select
                                                        name="room"
                                                        onChange={handleInputChange}
                                                        value={formData.room}
                                                        className={`form-input form-group-selection ${errors.room
                                                            ? "error"
                                                            : inputState.room
                                                                ? "success"
                                                                : ""
                                                            }`}
                                                    >
                                                        <option value="">Select venue</option>
                                                        {roomData?.available_rooms?.map((room) => (
                                                            <option value={room.room_id}>{room.room_name}</option>
                                                        ))}

                                                    </select>
                                                    <DropdownArrow />
                                                    <div>
                                                        {errors.venue && (
                                                            <span className="error-message font-size-text ">{errors.venue}</span>
                                                        )}
                                                    </div>
                                                </>}
                                        </div>
                                        :
                                        <div title="venue" className="flex-column" style={{ width: '23vw' }}>
                                            <label htmlFor="outside_venue" className="form-labels font-weight500 font-size-subheading" style={{ width: '23vw' }}>
                                                Venue
                                            </label>
                                            <input
                                                type="text"
                                                id="outside_venue"
                                                name="outside_venue"
                                                placeholder="Venue"
                                                onChange={handleInputChange}
                                                value={formData.outside_venue}
                                                className={`form-input ${errors.outside_venue ? "error" : inputState.outside_venue ? "success" : ""}`}
                                            />
                                            {errors.outside_venue && (
                                                <span className="error-message font-size-text">{errors.outside_venue}</span>
                                            )}
                                        </div>}
                                {
                                    formData.is_outsude === "false" &&
                                    <div title="isteam" className="form-group-selectt" style={{
                                        width: " 23vw",
                                        margin: " 0px 30px",
                                    }}>
                                        <label htmlFor="isteam" className="form-labels  font-weight500    font-size-subheading">
                                            Create Team
                                        </label>

                                        <select
                                            id="isteam"
                                            name="isteam"
                                            value={formData.isteam}
                                            onChange={handleInputChange}
                                            className="form-input form-group-selection"
                                        >
                                            <option value="">Create Team</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                        <DropdownArrow />
                                        <div>
                                            {errors.isteam && (
                                                <span className="error-message font-size-text ">{errors.isteam}</span>
                                            )}
                                        </div>
                                    </div>
                                }

                                {
                                    formData.is_outsude === "false" && formData.isteam === "Yes" ? (<>
                                        <div className="flex-column" style={{ width: '23vw' }}>
                                            <label htmlFor="existingteam" className="form-labels  font-weight500    font-size-subheading">
                                                Choose Team<span className="required">*</span>
                                            </label>
                                            <div className="form-inputt" value={formData.existingteam}
                                                onChange={handleInputChange}
                                            // style={{
                                            //     width: '30vw',
                                            //     display: 'flex',
                                            //     alignItems: 'center'
                                            // }}
                                            >
                                                <input
                                                    className="age-input"
                                                    type="radio"
                                                    checked={formData.existingteam === "Yes"}
                                                    name="existingteam"
                                                    value="Yes"
                                                />
                                                <label className="age-label   font-weight500    font-size-heading">Select Existing</label>

                                                <input
                                                    className="age-input"
                                                    type="radio"
                                                    checked={formData.existingteam === "CreateNew"}
                                                    name="existingteam"
                                                    value="CreateNew"
                                                />
                                                <label className="age-label   font-weight500    font-size-heading">Create New</label>
                                            </div>
                                        </div></>) : (<>
                                            <div title="participants" className="flex-column">
                                                <label htmlFor="participants" className="form-labels font-weight500 font-size-subheading">
                                                    Participants                                            </label>
                                                <Select
                                                    options={options}
                                                    isMulti
                                                    onChange={(selectedOptions) => {
                                                        // Update assignedto with objects containing value and mandatory properties
                                                        const updatedParticipants = selectedOptions.map((option) => ({
                                                            value: option.value,
                                                            label: option.label,
                                                            mandatory: option.mandatory || false, // Default to non-mandatory if not defined
                                                        }));
                                                        selectEmployee(updatedParticipants); // Save the selected participants
                                                    }}
                                                    value={formData.assignedto?.map((participant) => ({
                                                        value: participant.value,
                                                        label: options.find((opt) => opt.value === participant.value)?.label || participant.value,
                                                        mandatory: participant.mandatory,
                                                    }))}
                                                    getOptionLabel={(e) => (
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <span>{e.label}</span>
                                                            <input
                                                                type="checkbox"
                                                                checked={e.mandatory}  // Set the checkbox status based on whether the participant is mandatory
                                                                onChange={() => handleToggleMandatory(e.value)} // Toggle the mandatory flag
                                                                style={{ marginLeft: '10px' }}
                                                            />
                                                        </div>
                                                    )}
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            width: '20vw',
                                                            minHeight: '50px',
                                                            borderRadius: '10px',
                                                            border: '1px solid #e3e3e3',
                                                            margin: '10px 0px 20px 0px',
                                                            padding: '0px 10px',
                                                        }),
                                                        option: (provided) => ({
                                                            ...provided,
                                                            backgroundColor: '#ffffff',
                                                            ':active': {
                                                                backgroundColor: '#e3e3e3',
                                                            },
                                                        }),
                                                    }}
                                                />
                                                {errors.participants && (
                                                    <span className="error-message font-size-text">{errors.participants}</span>
                                                )}
                                            </div>


                                            {/* // Handle toggling of mandatory flag for each selected participant */}


                                        </>)}
                                {
                                    formData.is_outsude === "false" ? (<>


                                        {formData.isteam === "Yes" ? (<>


                                            {formData.existingteam === "CreateNew" ? (
                                                <>
                                                    <div style={{ width: '100%' }}>
                                                        <div className="jd-heading-outer  heading-bg-color-white">
                                                            <div className="jd-heading-outer-flex ">
                                                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                                                    Create Team{" "}
                                                                </h2>
                                                                <div>

                                                                    <button title="Add Documents" onClick={handleSubmitteam}
                                                                        className="upload-svg" type="button" style={{ float: 'right' }}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_1415_3177)"><path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z" fill="white"></path></g><defs><clipPath id="clip0_1415_3177"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg> Create Team</button>
                                                                    <br />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className="jd-heading-bottom-bold"></div>
                                                                <div className="jd-heading-bottom-light"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-flex-wrap" style={{
                                                        width: "100%", JustifyContent: 'space-around', display: 'flex', gap: "8px",

                                                    }}>
                                                        <div title="venue" className="flex-column" style={{ width: "10vw" }} >
                                                            <label
                                                                htmlFor="team_name"
                                                                className="form-labels announce-date font-weight500 font-size-heading"
                                                            >
                                                                Team Name <span className="required">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="team_name"
                                                                name="team_name"
                                                                placeholder="Enter Team Name"
                                                                value={formData.team_name}
                                                                onChange={handleInputChange}
                                                                className={`form-input ${errors.team_name ? "error" : ""}`}
                                                                style={{ width: "20vw" }}
                                                            />
                                                            {errors.team_name && (
                                                                <span className="error-message font-size-text">
                                                                    {errors.team_name}
                                                                </span>
                                                            )}
                                                        </div>

                                                        {/* Department */}
                                                        <div className="flex-column form-group-selectt" style={{ width: '23vw' }}>
                                                            <label className="form-labels  font-weight500 font-size-subheading">
                                                                Department Name<span className="required">*</span>
                                                            </label>

                                                            {departmentname.length === 0 ?
                                                                <div className="form-loader">
                                                                    <div className="bar-loader"></div>
                                                                </div>
                                                                : <>
                                                                    <select
                                                                        name="department"
                                                                        onChange={handleInputChange}
                                                                        value={formData.department}
                                                                        className={`form-input form-group-selection ${errors.department
                                                                            ? "error"
                                                                            : inputState.department
                                                                                ? "success"
                                                                                : ""
                                                                            }`}
                                                                    >
                                                                        <option value="">Select Department</option>
                                                                        {departmentname?.map((department) => (
                                                                            <option value={department.id}>{department.sub_company_name}</option>
                                                                        ))}

                                                                    </select>
                                                                    <DropdownArrow />
                                                                    <div>
                                                                        {errors.department && (
                                                                            <span className="error-message font-size-text ">{errors.department}</span>
                                                                        )}
                                                                    </div>
                                                                </>}
                                                        </div>

                                                        {/* Participants */}


                                                        <div title="participants" className="flex-column">
                                                            <label htmlFor="participants" className="form-labels font-weight500 font-size-subheading">
                                                                Participants
                                                            </label>
                                                            <Select
                                                                options={options}
                                                                isMulti
                                                                onChange={selectTeamparticipint}
                                                                value={formData.assignedto?.map((code) => ({
                                                                    value: code,
                                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                                }))}

                                                                styles={{
                                                                    control: (provided, state) => {

                                                                        const selectedValue = state.getValue()[0]?.value;
                                                                        const selectedOption = options != undefined && options.find((opt) => opt.value === selectedValue);
                                                                        const isAvailable = selectedOption ? selectedOption.isAvailable : true;





                                                                        return {
                                                                            ...provided,
                                                                            width: '23vw',
                                                                            minHeight: '50px',
                                                                            borderRadius: '10px',
                                                                            border: '1px solid #e3e3e3',
                                                                            margin: '10px 0px 20px 0px',
                                                                            color: isAvailable ? '#4a4a4a' : 'red',
                                                                            backgroundColor: isAvailable ? '#red' : '#ffebeb',
                                                                            padding: '0px 10px',
                                                                        };
                                                                    },
                                                                }}

                                                            />
                                                            {errors.participants && (
                                                                <span className="error-message font-size-text">{errors.participants}</span>
                                                            )}
                                                        </div>


                                                        {/* Submit Button */}
                                                        <div className="button-models" style={{ width: '100%' }}>

                                                        </div>
                                                    </div></>) : (<>
                                                        <div className="flex-column form-group-selectt">
                                                            <label className="form-labels  font-weight500 font-size-subheading">
                                                                Existing Team<span className="required">*</span>
                                                            </label>
                                                            <br />
                                                            {teamlist.length === 0 ?
                                                                <div className="form-loader">
                                                                    <div className="bar-loader"></div>
                                                                </div>
                                                                : <>
                                                                    <select
                                                                        name="team"
                                                                        onChange={handleInputChange}
                                                                        value={formData.team}
                                                                        className={`form-input form-group-selection ${errors.room
                                                                            ? "error"
                                                                            : inputState.room
                                                                                ? "success"
                                                                                : ""
                                                                            }`}
                                                                    >
                                                                        <option value="">Select Team</option>
                                                                        {teamlist?.map((team) => (
                                                                            <option value={team.id}>{team.team_name}</option>
                                                                        ))}

                                                                    </select>
                                                                    <DropdownArrow />
                                                                    <div>
                                                                        {errors.venue && (
                                                                            <span className="error-message font-size-text ">{errors.venue}</span>
                                                                        )}
                                                                    </div>
                                                                </>}
                                                        </div>
                                                    </>
                                            )}
                                        </>) : (<>


                                        </>)}

                                    </>) : <>
                                        {formData.outside_participants.map((participant, index) => (
                                            <div key={index} className="">
                                                <label htmlFor={`participant_name_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                    Participant Name {index + 1}
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`participant_name_${index}`}
                                                    name="name"
                                                    placeholder="Name"
                                                    value={participant.name}
                                                    onChange={(e) => handleParticipantChange(index, 'name', e.target.value)}
                                                    className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""}`}
                                                />

                                                <label htmlFor={`participant_email_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                    Participant Email {index + 1}
                                                </label>
                                                <input
                                                    type="email"
                                                    id={`participant_email_${index}`}
                                                    name="email"
                                                    placeholder="Email"
                                                    value={participant.email}
                                                    onChange={(e) => handleParticipantChange(index, 'email', e.target.value)}
                                                    className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""}`}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => handleDeleteParticipant(index)}
                                                    className="delete-participant-btn"
                                                >
                                                    Delete
                                                </button>
                                                {isAddButtonVisible && (
                                                    <button
                                                        type="button"
                                                        onClick={handleAddParticipant}
                                                        className="add-participant-btn"
                                                    >
                                                        +
                                                    </button>
                                                )}
                                            </div>

                                        ))}

                                        {/* Add Participant Button */}

                                    </>
                                }



                                {/* Participants Addition Type */}
                                {/* {
                                formData.is_outsude === "true" && <div title="participants" className="flex-column">
                                    <label htmlFor="participants" className="form-labels font-weight500 font-size-subheading">
                                        Participants1
                                    </label>
                                    <Select
                                        options={options}
                                        isMulti
                                        onChange={selectEmployee}
                                        value={formData.assignedto?.map((code) => ({
                                            value: code,
                                            label: options.find((opt) => opt.value === code)?.label || code,
                                        }))}
                                        styles={{
                                            control: (provided, state) => {
                                                const selectedValue = state.getValue()[0]?.value;
                                                const selectedOption = options != undefined && options.find((opt) => opt.value === selectedValue);
                                                const isAvailable = selectedOption ? selectedOption.isAvailable : true;



                                                return {
                                                    ...provided,
                                                    width: '20vw',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: isAvailable ? '#4a4a4a' : 'red', // Use red for unavailable
                                                    backgroundColor: isAvailable ? '#f7f8fa' : '#ffebeb', // Light red background for unavailable
                                                    padding: '0px 10px',
                                                };
                                            },
                                            option: (provided, state) => {
                                                const option = options.find(opt => opt.value === state.data.value);
                                                const isAvailable = option ? option.isAvailable : true;

                                                return {
                                                    ...provided,
                                                    backgroundColor: isAvailable ? '#ffffff' : '#ffebeb', // Light red background for unavailable
                                                    color: isAvailable ? '#4a4a4a' : 'red', // Use red for unavailable
                                                    ':active': {
                                                        backgroundColor: isAvailable ? '#e3e3e3' : '#ffcccc', // Darker red for active state
                                                    },
                                                };
                                            },
                                            singleValue: (provided, state) => {
                                                const option = options.find(opt => opt.value === state.data.value);
                                                const isAvailable = option ? option.isAvailable : true;

                                                return {
                                                    ...provided,
                                                    color: isAvailable ? '#4a4a4a' : 'red',
                                                };
                                            },
                                        }}
                                    />
                                    {errors.participants && (
                                        <span className="error-message font-size-text">{errors.participants}</span>
                                    )}
                                </div>

                            } */}



                                {/* Submit Button */}
                                <div className="button-models" style={{ width: '100%', justifyContent: "center", gap: '30px' }}>
                                    {formData.start_time && formData.end_time && (
                                        <p
                                            style={{ display: "flex", justifyContent: 'center', gap: '30px', alignItems: 'center' }}
                                        >

                                            <label className="font-weight500 font-size-subheading">
                                                Meeting Duration
                                            </label>
                                            <span className="duration-display">
                                                {calculateDuration(formData.start_time, formData.end_time)}
                                            </span>
                                        </p>

                                    )}
                                    <button
                                        onClick={handleSubmit}
                                        className="model-button font-weight500 model-button-submit"
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>




                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const UpdateEventModal = ({ showModal, onClose, selectedEvent, dayPosition, timeSlots, setShowModalupdate, selectedTimeslot, getMeetingData, Handlecloseallmodal, closeMeetingModal, modaltoogleOption, selectedDate }) => {
    const [isVisible, setIsVisible] = useState(false); // Controls visibility
    const [isMounted, setIsMounted] = useState(false); // Controls mounting
    console.log(selectedEvent, 'update selected event')
    const [formData, setFormData] = useState({
        title: "",
        participants: [],
        created_at: "",
        discription: "",
        organizer: sessionStorage.getItem("emp_code"),
        meeting_date: "",
        start_time: "",
        end_time: "",
        outside_venue: "",
        mandatory: false,
        participants_addition_type: "",
        decline_reason: null,
        optional_participents: [],
        room: [],
        isteam: 'No',
        is_outsude: "false",
        outside_email: '',
        team_name: "",
        department: "",
        participants: [],
        participantsteam: '',
        existingteam: "",
        team: "",
        outside_venue: "",
        outside_participants: [
            { name: '', email: '' }
        ]
    });
    const modalRef = useRef(null);
    const [isClock, setIsClock] = useState(false);
    const [isClockend, setIsClockend] = useState(false);
    const [firsttime, Setfirstime] = useState(true);

    const [roomData, setRoomData] = useState('')
    const getRoomdata = async () => {
        try {

            const result = await axios.get(`${BASE_URL}/meetingscheduler/roomavailabilitycheck/${formData.meeting_date}/${formData.start_time}/${formData.end_time}/`);

            setRoomData(result.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            // setLoading(false); //loading logic
            // toast.dismiss(loadingToastId);
        }


    };

    const [teamlist, SetTeamlist] = useState([]);
    const getTeamdata = async () => {
        try {

            const result = await axios.get(`${BASE_URL}/meetingscheduler/team/`);

            SetTeamlist(result.data);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            // setLoading(false); //loading logic
            // toast.dismiss(loadingToastId);
        }


    };

    const [allemployee, setAllemployee] = useState([]);
    const getAllEmployee = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/meetingscheduler/employeesavailabilityfilterV2/${formData.meeting_date}/${formData.start_time}/${formData.end_time}/`);
            setAllemployee(res.data)
            // setFilteredEmployee(res.data)
        } catch (err) {
            // alert(err.message);
        }
    };

    const [departmentname, setDepartmentname] = useState([]);
    const [selectedSubCompany, setSelectedSubCompany] = useState('');
    const getDepartment = async () => {
        try {
            const result = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/null/active/`);

            setDepartmentname(result.data)
        } catch (err) {

        } finally {

        }
    };
    const [firsttime1, setFirstime1] = useState(false)
    useEffect(() => {
        if (showModal) {
            setFirstime1(false);

            setFormData((prevFormData) => ({
                ...selectedEvent, // Keep the rest of the formData as selectedEvent
                is_outsude: selectedEvent?.is_outside ? "True" : "false", // Update is_outsude
                is_team: selectedEvent?.is_team === "No" ? "No" : "Yes", // Update is_team
            }));
        }
    }, [showModal, selectedEvent]);

    console.log(formData, 'formdata')
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [loading, setLoading] = useState(false);
    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;

        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }


        if (name === "meeting_date" && value) {

            const selectedDate = new Date(value);
            const currentDate = new Date();


            selectedDate.setHours(0, 0, 0, 0);
            currentDate.setHours(0, 0, 0, 0);


            if (selectedDate < currentDate) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Meeting date cannot be in the past.",
                }));
                return;
            } else {

                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "",
                }));
            }
        }

        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };
    const validateform = () => {
        const newErrors = {};
        const requiredFields = [
            "title",
            "start_time",
            "end_time",
            "meeting_date",
            "room",


        ];

        requiredFields.forEach((field) => {

            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        // setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };
    const validateformTeam = () => {
        const newErrors = {};
        const requiredFields = [
            "team_name",
            "department",
            "participants",

        ];

        requiredFields.forEach((field) => {

            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        // setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const meetingDate = new Date(formData.meeting_date);
        const currentDate = new Date();


        meetingDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        if (meetingDate < currentDate) {

            toast.error("Meeting date cannot be a previous date.");
            setLoading(false);
            return;
        }
        setLoading(true);

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {
                const dataToSend = {};

                dataToSend.title = formData?.title;
                dataToSend.discription = formData?.discription;

                dataToSend.created_at = formData?.created_at;
                dataToSend.organizer = formData?.organizer;
                dataToSend.meeting_date = formData?.meeting_date;
                dataToSend.start_time = formData?.start_time;
                dataToSend.end_time = formData?.end_time;

                dataToSend.mandatory = formData?.mandatory;

                dataToSend.decline_reason = formData?.decline_reason;
                dataToSend.optional_participents = formData?.optional_participents;
                if (formData.is_outsude === "true") {
                    dataToSend.outside_venue = formData?.outside_venue;
                    dataToSend.outside_participants = formData?.outside_participants;
                } else {
                    dataToSend.room = formData?.room;
                }


                dataToSend.is_team = formData.isteam === "Yes" ? true : false;
                dataToSend.is_outside = formData.is_outsude === "true" ? true : false;

                dataToSend.participants = formData?.participants;
                if (formData.isteam === "Yes") {
                    dataToSend.team_name = formData.team_name;
                    dataToSend.participantsteam = formData.participantsteam;
                    dataToSend.department = formData.department;
                    dataToSend.team = formData.team
                }


                let res = await axios.put(
                    `${BASE_URL}/meetingscheduler/meeting/${formData.id}`,
                    dataToSend,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (res.status === 201 || res.status === 200) {
                    await getMeetingData()
                    Handlecloseallmodal()
                } else {

                }


            } catch (err) {
                // toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false);
                // loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const handleSubmitteam = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (validateformTeam()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {

                const dataToSend = {};

                dataToSend.team_name = formData?.team_name;
                dataToSend.department = formData?.department;
                dataToSend.participants = formData?.participantsteam;


                let res = await axios.post(
                    `${BASE_URL}/meetingscheduler/team/`,
                    dataToSend,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (res.status === 201 || res.status === 200) {
                    // onRoomCreated(res.data);
                    // onClose();
                    await getTeamdata();
                    setFormData((prevState) => ({
                        ...prevState,
                        team: res.data.id,
                    }));
                } else {

                }


            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                // setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };



    useEffect(() => {

        if (formData.meeting_date != "" && formData.start_time != "" && formData.end_time != "") {

            getRoomdata();
            getAllEmployee();
            getDepartment();
            getTeamdata();
        }
    }, [formData.meeting_date, formData.start_time, formData.end_time, selectedEvent])

    const options = allemployee?.employees
        ?.sort((a, b) => parseInt(a.employee_id) - parseInt(b.employee_id))
        .map((e) => {



            return {
                value: e.employee_id,
                label: e.is_available
                    ? `${e.employee_id} - ${e.employee_name}`
                    : `${e.employee_id} - ${e.employee_name} (Booked)`,
                isAvailable: e.is_available,
            };
        });



    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const participants = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            participants,
        }));
    };


    const selectEmployeeoutside = (selected) => {

    };



    const selectTeamparticipint = (selected) => {

        const participantsteam = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            participantsteam,
        }));
    };

    const [selectedOption, setSelectedOption] = useState('');
    const [newTeamName, setNewTeamName] = useState('');
    const [assignedTo, setAssignedTo] = useState([]);

    const handleParticipantChange = (index, field, value) => {
        const updatedParticipants = [...formData.outside_participants];
        updatedParticipants[index][field] = value;

        setFormData({ ...formData, outside_participants: updatedParticipants });
    };
    const handleAddParticipant = () => {
        setFormData({
            ...formData,
            outside_participants: [...formData.outside_participants, { name: '', email: '' }],
        });
    };

    const handleDeleteParticipant = (index) => {
        const updatedParticipants = formData.outside_participants.filter((_, i) => i !== index);
        setFormData({ ...formData, outside_participants: updatedParticipants });
    };

    const isAddButtonVisible = formData?.outside_participants?.every(
        (participant) => participant.name && participant.email
    );


    // All other state and functions remain the same from the original component
    // ...

    // Calculate position relative to clicked day
    const calculatePosition = () => {
        if (!dayPosition) return {};

        // Default to center positioning if no dayPosition provided
        const defaultPosition = {
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        };

        if (!dayPosition.x || !dayPosition.y) return defaultPosition;

        // Get calendar dimensions
        const calendar = document.querySelector('.calendar-grid');
        if (!calendar) return defaultPosition;

        const calendarRect = calendar.getBoundingClientRect();

        // Calculate if modal would go off-screen
        const modalWidth = 600; // Estimate modal width
        const modalHeight = 500; // Estimate modal height

        let left = dayPosition.x;
        let top = dayPosition.y + 10; // Offset slightly below the day cell

        // Adjust if too close to right edge
        if (left + modalWidth > calendarRect.right) {
            left = dayPosition.x - modalWidth;
        }

        // Adjust if too close to bottom edge
        if (top + modalHeight > calendarRect.bottom) {
            top = dayPosition.y - modalHeight;
        }

        // Ensure modal doesn't go off the left or top edge
        left = Math.max(calendarRect.left, left);
        top = Math.max(calendarRect.top, top);

        return {
            position: 'absolute',
            left: `${left}px`,
            top: `${top}px`,
            transform: 'none'
        };
    };

    useEffect(() => {
        if (showModal) {
            setIsMounted(true); // Mount the modal
            setTimeout(() => setIsVisible(true), 10); // Slight delay to trigger CSS transition
        } else {
            setIsVisible(false); // Start fade-out transition
            setTimeout(() => setIsMounted(false), 300); // Unmount after transition
        }
    }, [showModal]);
    const [isExpanded, setIsExpanded] = useState(false);
    const handleClose = () => {
        console.log('clcikded close fun')
        // setShowModalupdate(false);
    }

    const handleTimeSelect = (selectedTime) => {
        setFormData((prevData) => ({
            ...prevData,
            start_time: selectedTime,
        }));

        // Calculate end time based on selected start time (for example, 1 hour duration)

    };

    const handleTimeSelectend = (selectedTime) => {
        setFormData((prevData) => ({
            ...prevData,
            end_time: selectedTime,
        }));



    };
    if (!isMounted) return null;

    const handleSelectClick = () => {
        setIsClock(!isClock);
    };

    const handleSelectClickend = () => {
        setIsClockend(!isClockend);
    }




    return (
        <>
            <div className={`calendar-meeting-modal ${isVisible ? 'visible' : ''}`}>

                <div
                    className="modal-content"
                    ref={modalRef}
                // style={calculatePosition()}
                >
                    <div className="modal-header">
                        <h2>Update Event</h2>
                        <button className="close-button" onClick={handleClose()}>
                            &times;
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* Form content remains the same */}
                        <form className="register-form">
                            <div className="form-flex-wrap">


                                <div title="is_outsude" className="flex-column form-group-selectt">
                                    <label htmlFor="is_outsude" className="form-labels  font-weight500    font-size-subheading">
                                        Meeting Type
                                    </label>

                                    <select
                                        id="is_outsude"
                                        name="is_outsude"
                                        value={formData.is_outsude}
                                        onChange={handleInputChange}
                                        className="form-input form-group-selection"
                                    >
                                        <option value="">Select Meeting Type</option>
                                        <option value="false">Inside</option>
                                        <option value="true">Outside</option>
                                    </select>
                                    <DropdownArrow />
                                    <div>
                                        {errors.is_outsude && (
                                            <span className="error-message font-size-text ">{errors.is_outsude}</span>
                                        )}
                                    </div>
                                </div>




                                <div title="title" className="flex-column">
                                    <label htmlFor="title" className="form-labels font-weight500 font-size-subheading">
                                        Meeting Agenda <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        placeholder="Meeting Agenda"
                                        onChange={handleInputChange}
                                        value={formData.title}
                                        className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""}`}
                                    />
                                    {errors.title && (
                                        <span className="error-message font-size-text">{errors.title}</span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label
                                        htmlFor="discription"
                                        className="form-labels font-weight500 font-size-subheading"

                                    >
                                        Meeting Description
                                    </label>
                                    <div
                                        onClick={() => setIsExpanded(!isExpanded)}
                                        className="expand-label"
                                    >
                                        <textarea
                                            id="discription"
                                            name="discription"
                                            placeholder="Enter meeting description"
                                            value={formData.discription}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.discription ? "error" : ""}`}
                                            style={{ minHeight: "20px", resize: "vertical", padding: '4px' }}

                                        />
                                    </div>
                                    {isExpanded && (
                                        <textarea
                                            id="discription"
                                            name="discription"
                                            placeholder="Enter meeting description"
                                            value={formData.discription}
                                            onChange={handleInputChange}

                                            className={`form-input ${errors.discription ? "error" : ""}`}
                                            style={{ minHeight: "150px", resize: "vertical", position: "absolute", top: "30px", zIndex: '999999999' }}
                                        />
                                    )}
                                    {errors.discription && (
                                        <span className="error-message font-size-text">
                                            {errors.discription}
                                        </span>
                                    )}
                                </div>




                                <div title="meeting_date" className="flex-column">
                                    <label htmlFor="meeting_date" className="form-labels font-weight500 font-size-subheading">
                                        Meeting Date <span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="meeting_date"
                                        name="meeting_date"
                                        onChange={handleInputChange}
                                        value={formData.meeting_date}
                                        className={`form-input ${errors.meeting_date ? "error" : inputState.meeting_date ? "success" : ""}`}
                                    />
                                    {errors.meeting_date && (
                                        <span className="error-message font-size-text">{errors.meeting_date}</span>
                                    )}
                                </div>


                                <div title="start_time" className="flex-column form-group-selectt" style={{ position: 'relative' }}>
                                    <label htmlFor="start_time" className="form-labels font-weight500 font-size-subheading">
                                        Start Time <span className="required">*</span>
                                    </label>


                                    <div
                                        id="start_time"
                                        className="form-input form-group-selection"
                                        onClick={handleSelectClick}
                                    // style={{ cursor: 'pointer', padding: '10px', border: '1px solid #ccc' }}
                                    >
                                        {formData.start_time ? (() => {
                                            const [hour, minute] = formData.start_time.split(':');
                                            const hourInt = parseInt(hour);
                                            const ampm = hourInt < 12 ? 'AM' : 'PM';
                                            const hour12 = hourInt % 12 || 12;
                                            return `${String(hour12).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;
                                        })() : 'Select Time'}
                                    </div>

                                    <DropdownArrow />

                                    <div>
                                        {errors.start_time && (
                                            <span className="error-message font-size-text">{errors.start_time}</span>
                                        )}
                                    </div>


                                    {isClock && (
                                        <MobileTimePicker initialTime={formData.start_time} onTimeSelect={handleTimeSelect} handleSelectClick={handleSelectClick} />
                                    )}
                                </div>

                                <div title="end_time" className="flex-column form-group-selectt" style={{ position: 'relative' }}>
                                    <label htmlFor="end_time" className="form-labels font-weight500 font-size-subheading">
                                        End Time <span className="required">*</span>
                                    </label>


                                    <div
                                        id="end_time"
                                        className="form-input form-group-selection"
                                        onClick={handleSelectClickend}
                                    // style={{ cursor: 'pointer', padding: '10px', border: '1px solid #ccc' }}
                                    >
                                        {formData.end_time ? (() => {
                                            const [hour, minute] = formData.end_time.split(':');
                                            const hourInt = parseInt(hour);
                                            const ampm = hourInt < 12 ? 'AM' : 'PM';
                                            const hour12 = hourInt % 12 || 12;
                                            return `${String(hour12).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;
                                        })() : 'Select Time'}
                                    </div>

                                    <DropdownArrow />

                                    <div>
                                        {errors.end_time && (
                                            <span className="error-message font-size-text">{errors.end_time}</span>
                                        )}
                                    </div>


                                    {isClockend && (
                                        <MobileTimePicker initialTime={formData.end_time} onTimeSelect={handleTimeSelectend} handleSelectClick={handleSelectClickend} />
                                    )}


                                </div>


                                {
                                    formData.is_outsude === "false" ?
                                        <div className="form-group-selectt" style={{ width: '23vw' }}>
                                            <label className="form-labels  font-weight500 font-size-subheading" style={{ width: '23vw' }}>
                                                Room<span className="required">*</span>
                                            </label>

                                            {roomData.length === 0 ?
                                                <div className="form-loader" style={{ width: '23vw' }}>
                                                    <div className="bar-loader" style={{ width: '23vw' }}></div>
                                                </div>
                                                : <>
                                                    <select
                                                        name="room"
                                                        onChange={handleInputChange}
                                                        value={formData.room}
                                                        className={`form-input form-group-selection ${errors.room
                                                            ? "error"
                                                            : inputState.room
                                                                ? "success"
                                                                : ""
                                                            }`}
                                                    >
                                                        <option value="">Select venue</option>
                                                        {roomData?.available_rooms?.map((room) => (
                                                            <option value={room.room_id}>{room.room_name}</option>
                                                        ))}

                                                    </select>
                                                    <DropdownArrow />
                                                    <div>
                                                        {errors.venue && (
                                                            <span className="error-message font-size-text ">{errors.venue}</span>
                                                        )}
                                                    </div>
                                                </>}
                                        </div>
                                        :
                                        <div title="venue" className="flex-column">
                                            <label htmlFor="outside_venue" className="form-labels font-weight500 font-size-subheading">
                                                Venue
                                            </label>
                                            <input
                                                type="text"
                                                id="outside_venue"
                                                name="outside_venue"
                                                placeholder="Venue"
                                                onChange={handleInputChange}
                                                value={formData.outside_venue}
                                                className={`form-input ${errors.outside_venue ? "error" : inputState.outside_venue ? "success" : ""}`}
                                            />
                                            {errors.outside_venue && (
                                                <span className="error-message font-size-text">{errors.outside_venue}</span>
                                            )}
                                        </div>

                                }
                                {
                                    formData.is_outsude === "false" &&
                                    <div title="isteam" className="form-group-selectt" style={{
                                        width: " 23vw",
                                        margin: " 0px 30px",
                                    }}>
                                        <label htmlFor="isteam" className="form-labels  font-weight500    font-size-subheading">
                                            Create Team
                                        </label>

                                        <select
                                            id="isteam"
                                            name="isteam"
                                            value={formData.isteam}
                                            onChange={handleInputChange}
                                            className="form-input form-group-selection"
                                        >
                                            <option value="">Create Team</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                        <DropdownArrow />
                                        <div>
                                            {errors.isteam && (
                                                <span className="error-message font-size-text ">{errors.isteam}</span>
                                            )}
                                        </div>
                                    </div>
                                }

                                {
                                    formData.is_outsude === "false" && formData.isteam === "Yes" ? (<>
                                        <div className="flex-column" style={{ width: '23vw' }}>
                                            <label htmlFor="existingteam" className="form-labels  font-weight500    font-size-subheading">
                                                Choose Team<span className="required">*</span>
                                            </label>
                                            <div className="form-inputt" value={formData.existingteam}
                                                onChange={handleInputChange}
                                            // style={{
                                            //     width: '30vw',
                                            //     display: 'flex',
                                            //     alignItems: 'center'
                                            // }}
                                            >
                                                <input
                                                    className="age-input"
                                                    type="radio"
                                                    checked={formData.existingteam === "Yes"}
                                                    name="existingteam"
                                                    value="Yes"
                                                />
                                                <label className="age-label   font-weight500    font-size-heading">Select Existing</label>

                                                <input
                                                    className="age-input"
                                                    type="radio"
                                                    checked={formData.existingteam === "CreateNew"}
                                                    name="existingteam"
                                                    value="CreateNew"
                                                />
                                                <label className="age-label   font-weight500    font-size-heading">Create New</label>
                                            </div>
                                        </div></>) : (<>
                                            <div title="participants" className="flex-column">
                                                <label htmlFor="participants" className="form-labels font-weight500 font-size-subheading">
                                                    Participants
                                                </label>
                                                <Select
                                                    options={options}
                                                    isMulti
                                                    onChange={selectEmployee}
                                                    value={formData.assignedto?.map((code) => ({
                                                        value: code,
                                                        label: options.find((opt) => opt.value === code)?.label || code,
                                                    }))}
                                                    styles={{
                                                        control: (provided, state) => {
                                                            const selectedValue = state.getValue()[0]?.value;
                                                            const selectedOption = options != undefined && options.find((opt) => opt.value === selectedValue);
                                                            const isAvailable = selectedOption ? selectedOption.isAvailable : true;



                                                            return {
                                                                ...provided,
                                                                width: '20vw',
                                                                minHeight: '50px',
                                                                borderRadius: '10px',
                                                                border: '1px solid #e3e3e3',
                                                                margin: '10px 0px 20px 0px',
                                                                color: isAvailable ? '#4a4a4a' : 'red',
                                                                backgroundColor: isAvailable ? '#f7f8fa' : '#ffebeb',
                                                                padding: '0px 10px',
                                                            };
                                                        },
                                                        option: (provided, state) => {
                                                            const option = options.find(opt => opt.value === state.data.value);
                                                            const isAvailable = option ? option.isAvailable : true;

                                                            return {
                                                                ...provided,
                                                                backgroundColor: isAvailable ? '#ffffff' : '#ffebeb',
                                                                color: isAvailable ? '#4a4a4a' : 'red',
                                                                ':active': {
                                                                    backgroundColor: isAvailable ? '#e3e3e3' : '#ffcccc',
                                                                },
                                                            };
                                                        },
                                                        singleValue: (provided, state) => {
                                                            const option = options.find(opt => opt.value === state.data.value);
                                                            const isAvailable = option ? option.isAvailable : true;

                                                            return {
                                                                ...provided,
                                                                color: isAvailable ? '#4a4a4a' : 'red',
                                                            };
                                                        },
                                                    }}
                                                />
                                                {errors.participants && (
                                                    <span className="error-message font-size-text">{errors.participants}</span>
                                                )}
                                            </div>
                                        </>)}
                                {
                                    formData.is_outsude === "false" ? (<>


                                        {formData.isteam === "Yes" ? (<>


                                            {formData.existingteam === "CreateNew" ? (
                                                <>
                                                    <div style={{ width: '100%' }}>
                                                        <div className="jd-heading-outer  heading-bg-color-white">
                                                            <div className="jd-heading-outer-flex ">
                                                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                                                    Create Team{" "}
                                                                </h2>
                                                                <div>

                                                                    <button title="Add Documents" onClick={handleSubmitteam}
                                                                        className="upload-svg" type="button" style={{ float: 'right' }}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_1415_3177)"><path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z" fill="white"></path></g><defs><clipPath id="clip0_1415_3177"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg> Create Team</button>
                                                                    <br />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className="jd-heading-bottom-bold"></div>
                                                                <div className="jd-heading-bottom-light"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-flex-wrap" style={{
                                                        width: "100%", JustifyContent: 'space-around', display: 'flex', gap: "8px",

                                                    }}>
                                                        <div title="venue" className="flex-column" style={{ width: "10vw" }} >
                                                            <label
                                                                htmlFor="team_name"
                                                                className="form-labels announce-date font-weight500 font-size-heading"
                                                            >
                                                                Team Name <span className="required">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="team_name"
                                                                name="team_name"
                                                                placeholder="Enter Team Name"
                                                                value={formData.team_name}
                                                                onChange={handleInputChange}
                                                                className={`form-input ${errors.team_name ? "error" : ""}`}
                                                                style={{ width: "20vw" }}
                                                            />
                                                            {errors.team_name && (
                                                                <span className="error-message font-size-text">
                                                                    {errors.team_name}
                                                                </span>
                                                            )}
                                                        </div>

                                                        {/* Department */}
                                                        <div className="flex-column form-group-selectt" style={{ width: '23vw' }}>
                                                            <label className="form-labels  font-weight500 font-size-subheading">
                                                                Department Name<span className="required">*</span>
                                                            </label>

                                                            {departmentname.length === 0 ?
                                                                <div className="form-loader">
                                                                    <div className="bar-loader"></div>
                                                                </div>
                                                                : <>
                                                                    <select
                                                                        name="department"
                                                                        onChange={handleInputChange}
                                                                        value={formData.department}
                                                                        className={`form-input form-group-selection ${errors.department
                                                                            ? "error"
                                                                            : inputState.department
                                                                                ? "success"
                                                                                : ""
                                                                            }`}
                                                                    >
                                                                        <option value="">Select Department</option>
                                                                        {departmentname?.map((department) => (
                                                                            <option value={department.id}>{department.sub_company_name}</option>
                                                                        ))}

                                                                    </select>
                                                                    <DropdownArrow />
                                                                    <div>
                                                                        {errors.department && (
                                                                            <span className="error-message font-size-text ">{errors.department}</span>
                                                                        )}
                                                                    </div>
                                                                </>}
                                                        </div>

                                                        {/* Participants */}


                                                        <div title="participants" className="flex-column">
                                                            <label htmlFor="participants" className="form-labels font-weight500 font-size-subheading">
                                                                Participants
                                                            </label>
                                                            <Select
                                                                options={options}
                                                                isMulti
                                                                onChange={selectTeamparticipint}
                                                                value={formData.assignedto?.map((code) => ({
                                                                    value: code,
                                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                                }))}

                                                                styles={{
                                                                    control: (provided, state) => {

                                                                        const selectedValue = state.getValue()[0]?.value;
                                                                        const selectedOption = options != undefined && options.find((opt) => opt.value === selectedValue);
                                                                        const isAvailable = selectedOption ? selectedOption.isAvailable : true;





                                                                        return {
                                                                            ...provided,
                                                                            width: '23vw',
                                                                            minHeight: '50px',
                                                                            borderRadius: '10px',
                                                                            border: '1px solid #e3e3e3',
                                                                            margin: '10px 0px 20px 0px',
                                                                            color: isAvailable ? '#4a4a4a' : 'red',
                                                                            backgroundColor: isAvailable ? '#red' : '#ffebeb',
                                                                            padding: '0px 10px',
                                                                        };
                                                                    },
                                                                }}

                                                            />
                                                            {errors.participants && (
                                                                <span className="error-message font-size-text">{errors.participants}</span>
                                                            )}
                                                        </div>


                                                        {/* Submit Button */}
                                                        <div className="button-models" style={{ width: '100%' }}>

                                                        </div>
                                                    </div></>) : (<>
                                                        <div className="flex-column form-group-selectt">
                                                            <label className="form-labels  font-weight500 font-size-subheading">
                                                                Existing Team<span className="required">*</span>
                                                            </label>
                                                            <br />
                                                            {teamlist.length === 0 ?
                                                                <div className="form-loader">
                                                                    <div className="bar-loader"></div>
                                                                </div>
                                                                : <>
                                                                    <select
                                                                        name="team"
                                                                        onChange={handleInputChange}
                                                                        value={formData.team}
                                                                        className={`form-input form-group-selection ${errors.room
                                                                            ? "error"
                                                                            : inputState.room
                                                                                ? "success"
                                                                                : ""
                                                                            }`}
                                                                    >
                                                                        <option value="">Select Team</option>
                                                                        {teamlist?.map((team) => (
                                                                            <option value={team.id}>{team.team_name}</option>
                                                                        ))}

                                                                    </select>
                                                                    <DropdownArrow />
                                                                    <div>
                                                                        {errors.venue && (
                                                                            <span className="error-message font-size-text ">{errors.venue}</span>
                                                                        )}
                                                                    </div>
                                                                </>}
                                                        </div>
                                                    </>
                                            )}
                                        </>) : (<>


                                        </>)}

                                    </>) : <>
                                        {formData.outside_participants.map((participant, index) => (
                                            <div key={index} className="">
                                                <label htmlFor={`participant_name_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                    Participant Name {index + 1}
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`participant_name_${index}`}
                                                    name="name"
                                                    placeholder="Name"
                                                    value={participant.name}
                                                    onChange={(e) => handleParticipantChange(index, 'name', e.target.value)}
                                                    className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""}`}
                                                />

                                                <label htmlFor={`participant_email_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                    Participant Email {index + 1}
                                                </label>
                                                <input
                                                    type="email"
                                                    id={`participant_email_${index}`}
                                                    name="email"
                                                    placeholder="Email"
                                                    value={participant.email}
                                                    onChange={(e) => handleParticipantChange(index, 'email', e.target.value)}
                                                    className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""}`}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => handleDeleteParticipant(index)}
                                                    className="delete-participant-btn"
                                                >
                                                    Delete
                                                </button>
                                                {isAddButtonVisible && (
                                                    <button
                                                        type="button"
                                                        onClick={handleAddParticipant}
                                                        className="add-participant-btn"
                                                    >
                                                        +
                                                    </button>
                                                )}
                                            </div>

                                        ))}

                                        {/* Add Participant Button */}

                                    </>
                                }



                                {/* Participants Addition Type */}
                                {
                                    formData.is_outsude === "true" && <div title="participants" className="flex-column">
                                        <label htmlFor="participants" className="form-labels font-weight500 font-size-subheading">
                                            Participants
                                        </label>
                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectEmployee}
                                            value={formData.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided, state) => {
                                                    const selectedValue = state.getValue()[0]?.value;
                                                    const selectedOption = options != undefined && options.find((opt) => opt.value === selectedValue);
                                                    const isAvailable = selectedOption ? selectedOption.isAvailable : true;



                                                    return {
                                                        ...provided,
                                                        width: '20vw',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: isAvailable ? '#4a4a4a' : 'red', // Use red for unavailable
                                                        backgroundColor: isAvailable ? '#f7f8fa' : '#ffebeb', // Light red background for unavailable
                                                        padding: '0px 10px',
                                                    };
                                                },
                                                option: (provided, state) => {
                                                    const option = options.find(opt => opt.value === state.data.value);
                                                    const isAvailable = option ? option.isAvailable : true;

                                                    return {
                                                        ...provided,
                                                        backgroundColor: isAvailable ? '#ffffff' : '#ffebeb', // Light red background for unavailable
                                                        color: isAvailable ? '#4a4a4a' : 'red', // Use red for unavailable
                                                        ':active': {
                                                            backgroundColor: isAvailable ? '#e3e3e3' : '#ffcccc', // Darker red for active state
                                                        },
                                                    };
                                                },
                                                singleValue: (provided, state) => {
                                                    const option = options.find(opt => opt.value === state.data.value);
                                                    const isAvailable = option ? option.isAvailable : true;

                                                    return {
                                                        ...provided,
                                                        color: isAvailable ? '#4a4a4a' : 'red',
                                                    };
                                                },
                                            }}
                                        />
                                        {errors.participants && (
                                            <span className="error-message font-size-text">{errors.participants}</span>
                                        )}
                                    </div>

                                }



                                {/* Submit Button */}
                                <div className="button-models" style={{ width: '100%', justifyContent: "center", gap: '30px' }}>
                                    {formData.start_time && formData.end_time && (
                                        <p
                                            style={{ display: "flex", justifyContent: 'center', gap: '30px', alignItems: 'center' }}
                                        >

                                            <label className="font-weight500 font-size-subheading">
                                                Meeting Duration
                                            </label>
                                            <span className="duration-display">
                                                {calculateDuration(formData.start_time, formData.end_time)}
                                            </span>
                                        </p>

                                    )}
                                    <button
                                        onClick={handleSubmit}
                                        className="model-button font-weight500 model-button-submit"
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>




                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const AllEventMiniModal = ({ showModal, onClose, selectedEventmini, dayPosition, showModaldetail, setShowModaldetail, handleShowAllEventDetail, handleShowAllUpdate, getMeetingData, timeSlots, closeMeetingModal, modaltoogleOption, selectedDate, selectedTimeslot }) => {
    const [isVisible, setIsVisible] = useState(false); // Controls visibility
    const [isMounted, setIsMounted] = useState(false); // Controls mounting

    const modalRef = useRef(null);



    // All other state and functions remain the same from the original component
    // ...

    // Calculate position relative to clicked day
    const calculatePosition = () => {
        if (!dayPosition) return {};

        // Default to center positioning if no dayPosition provided
        const defaultPosition = {
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        };

        if (!dayPosition.x || !dayPosition.y) return defaultPosition;

        // Get calendar dimensions
        const calendar = document.querySelector('.calendar-grid');
        if (!calendar) return defaultPosition;

        const calendarRect = calendar.getBoundingClientRect();

        // Calculate if modal would go off-screen
        const modalWidth = 600; // Estimate modal width
        const modalHeight = 500; // Estimate modal height

        let left = dayPosition.x;
        let top = dayPosition.y + 10; // Offset slightly below the day cell

        // Adjust if too close to right edge
        if (left + modalWidth > calendarRect.right) {
            left = dayPosition.x - modalWidth;
        }

        // Adjust if too close to bottom edge
        if (top + modalHeight > calendarRect.bottom) {
            top = dayPosition.y - modalHeight;
        }

        // Ensure modal doesn't go off the left or top edge
        left = Math.max(calendarRect.left, left);
        top = Math.max(calendarRect.top, top);

        return {
            position: 'absolute',
            left: `${left}px`,
            top: `${top}px`,
            transform: 'none'
        };
    };

    useEffect(() => {
        if (showModal) {
            setIsMounted(true); // Mount the modal
            setTimeout(() => setIsVisible(true), 10); // Slight delay to trigger CSS transition
        } else {
            setIsVisible(false); // Start fade-out transition
            setTimeout(() => setIsMounted(false), 300); // Unmount after transition
        }
    }, [showModal]);

    if (!isMounted) return null; // Don't render if not mounted



    return (
        <div className={`calendar-meeting-modal ${isVisible ? 'visible' : ''}`}>

            <div
                className="modal-content"
                ref={modalRef}
                style={{ maxWidth: '300px' }}
            >
                <div className="modal-header">
                    <h2>Day Events   {selectedDate?.toLocaleDateString("en-US", {
                        month: "long",
                        day: "numeric",
                        year: "numeric",
                    })}</h2>
                    <button className="close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">

                    <ul className="meeting-list" style={{ margin: "8px 4px 20px 4px" }}>
                        {selectedEventmini.length > 0 &&
                            selectedEventmini.map((event, index) => (
                                <li key={event.id} className="mini-modal-item">
                                    <p onClick={(e) => {
                                        // onClose()
                                        handleShowAllEventDetail(e, event)
                                    }}> <span>{event.title}</span><span></span>{event.start_time} <span>{`${event.room ? event.room : event.venue}`}</span></p>
                                    {/* <AllEventDetailModal showModal={showModaldetail}
  onClose={()=>setShowModaldetail(false)}
  selectedEvent={[event]}
    dayPosition={dayPosition}
    handleShowAllUpdate={handleShowAllUpdate}
  /> */}
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

const AllEventDetailModal = ({ showModal, setShowModaldetail, onClose, selectedEvent, dayPosition, showModalupdate,
    setShowModalupdate, handleShowAllUpdate, timeSlots, day,
    selectedDay,
    selectedTimeslot, SelectedEventupdate }) => {
    const [isVisible, setIsVisible] = useState(false); // Controls visibility

    const [isMounted, setIsMounted] = useState(false); // Controls mounting

    console.log(day,
        selectedDay)


    const calculatePosition = () => {
        if (!dayPosition) return {};

        // Default to center positioning if no dayPosition provided
        const defaultPosition = {
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        };

        if (!dayPosition.x || !dayPosition.y) return defaultPosition;

        // Get calendar dimensions
        const calendar = document.querySelector('.calendar-grid');
        if (!calendar) return defaultPosition;

        const calendarRect = calendar.getBoundingClientRect();

        // Calculate if modal would go off-screen
        const modalWidth = 600; // Estimate modal width
        const modalHeight = 500; // Estimate modal height

        let left = dayPosition.x;
        let top = dayPosition.y + 10; // Offset slightly below the day cell

        // Adjust if too close to right edge
        if (left + modalWidth > calendarRect.right) {
            left = dayPosition.x - modalWidth;
        }

        // Adjust if too close to bottom edge
        if (top + modalHeight > calendarRect.bottom) {
            top = dayPosition.y - modalHeight;
        }

        // Ensure modal doesn't go off the left or top edge
        left = Math.max(calendarRect.left, left);
        top = Math.max(calendarRect.top, top);

        return {
            position: 'absolute',
            left: `${left}px`,
            top: `${top}px`,
            transform: 'none'
        };
    };

    useEffect(() => {
        if (showModal) {
            setIsMounted(true); // Mount the modal
            setTimeout(() => setIsVisible(true), 10); // Slight delay to trigger CSS transition
        } else {
            setIsVisible(false); // Start fade-out transition
            setTimeout(() => setIsMounted(false), 300); // Unmount after transition
        }
    }, [showModal]);

    console.log(selectedEvent)

    if (!isMounted) return null;

    const handleClose = () => {
        console.log('handleclose clicked ')
        setShowModaldetail(false);
    }

    return (
        <div className={`calendar-meeting-modal ${isVisible && showModal ? 'visible' : ''}`}>

            <div
                className="modal-content"
                style={{ maxWidth: '30%' }}
            // style={calculatePosition()}
            >
                <div className="modal-header">
                    <h2>Day Events</h2>
                    <button className="close-button" onClick={handleClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    {selectedEvent != undefined &&
                        <ul className="meeting-list">
                            {selectedEvent != undefined && selectedEvent?.length > 0 &&
                                selectedEvent?.map((event, index) => (
                                    <li key={event.id} className="meeting-item all-meeting-details">
                                        <div className="meeting-details">

                                            <p>
                                                <strong>Title:</strong> {event.title}
                                            </p>
                                            <p>
                                                <strong>Room Name:</strong> {event.room_name}
                                            </p>
                                            <p>
                                                <strong>Meeting Date:</strong> {event.meeting_date}
                                            </p>
                                            <p>
                                                <strong>Start Time:</strong> {event.start_time}
                                            </p>
                                            <p>
                                                <strong>End Time:</strong> {event.end_time}
                                            </p>
                                            <p>
                                                <strong>Organizer:</strong> {event.organizer}
                                            </p>
                                            <p>
                                                <strong>Participants:</strong>{" "}
                                                {event?.participant_details
                                                    ?.map((participant) => participant.name)
                                                    .join(", ")}
                                            </p>
                                            <p>
                                                <strong>Recurrence:</strong> {event.is_recurrence ? "Yes" : "No"}
                                            </p>
                                        </div>
                                        <div className="meeting-actions">

                                            <button
                                                onClick={(e) => {
                                                    handleClose()
                                                    handleShowAllUpdate(e, event)
                                                }}
                                                className="action-button"
                                            >
                                                Edit
                                            </button>
                                            <button
                                                // onClick={() => handleDeleteEvent(event.id)}
                                                className="action-button"
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </li>
                                ))}
                        </ul>}
                    {/* <UpdateEventModal
                 showModal={showModalupdate}
                 onClose={() => setShowModalupdate(false)}
                 dayPosition={dayPosition}
                 timeSlots={timeSlots}
                 selectedTimeslot={selectedTimeslot}
                 selectedEvent={SelectedEventupdate}
                 /> */}

                </div>
            </div>
        </div>
    );
};


export { AddEventModal, UpdateEventModal, AllEventMiniModal, AllEventDetailModal };